"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InputSelect = void 0;
const react_1 = __importStar(require("react"));
const useClickOutside_1 = require("./useClickOutside");
const inputs_select_drawer_1 = require("./inputs-select-drawer");
const inputs_drawer_multiple_1 = require("./inputs-drawer-multiple");
const vobaza_ui_icon_1 = require("@nebo-team-dev/vobaza.ui.icon");
const input_select_styled_1 = require("./input-select.styled");
function InputSelect(_a) {
    var { label, name, variants, currentValue, error, notion, withSearch, disabled = false, multiple = false, required = false, keyField = 'code', valueField = 'value', onChange, renderAfter, onRenderAfterClick } = _a, restProps = __rest(_a, ["label", "name", "variants", "currentValue", "error", "notion", "withSearch", "disabled", "multiple", "required", "keyField", "valueField", "onChange", "renderAfter", "onRenderAfterClick"]);
    const selectRef = (0, react_1.useRef)(null);
    const [isOpen, setIsOpen] = (0, react_1.useState)(false);
    const [normalizedValue, setNormalizedValue] = (0, react_1.useState)(null);
    const handleChangeMultipleSelect = (item, isSelect) => {
        if (!Array.isArray(normalizedValue))
            return;
        let newSelected = [...normalizedValue];
        if (isSelect) {
            newSelected.push(item);
        }
        else {
            newSelected = newSelected.filter((t) => t[keyField] !== item[keyField]);
        }
        onChange && onChange(newSelected);
    };
    const handleChangeSelect = (item) => {
        onChange && onChange(item);
        item.onClick && item.onClick();
        setIsOpen(false);
    };
    const handleToggleDrawer = () => {
        if (!disabled)
            setIsOpen(!isOpen);
    };
    const parseValue = () => {
        const displayValue = Array.isArray(normalizedValue)
            ? normalizedValue[0]
            : normalizedValue;
        const isSeveralItems = Array.isArray(normalizedValue) && normalizedValue.length > 1;
        if (displayValue) {
            return (react_1.default.createElement(input_select_styled_1.StyledValueWrapper, null,
                react_1.default.createElement(input_select_styled_1.StyledValue, null, displayValue[valueField] || ''),
                isSeveralItems && (react_1.default.createElement(input_select_styled_1.StyledValueBlueSpan, null,
                    "\u0438 \u0435\u0449\u0451 ",
                    normalizedValue.length - 1))));
        }
        return null;
    };
    (0, useClickOutside_1.useClickOutside)(selectRef, () => setIsOpen(false));
    (0, react_1.useEffect)(() => {
        if (multiple) {
            const value = Array.isArray(currentValue)
                ? [...currentValue]
                : [currentValue];
            setNormalizedValue(value.filter((t) => !!t));
        }
        else {
            const value = Array.isArray(currentValue)
                ? currentValue[0]
                : currentValue;
            setNormalizedValue(value || null);
        }
    }, [currentValue, multiple]);
    const isFocus = multiple
        ? Array.isArray(normalizedValue) && normalizedValue.length
        : !!normalizedValue;
    const inputContainerClasses = [
        disabled ? 'disabled' : '',
        isFocus ? 'focus' : '',
    ].join(' ');
    const parsedValue = parseValue();
    return (react_1.default.createElement(input_select_styled_1.StyledField, Object.assign({ ref: selectRef }, restProps),
        react_1.default.createElement(input_select_styled_1.StyledField, { onClick: handleToggleDrawer, "data-testid": "input-select-clickable" },
            react_1.default.createElement(input_select_styled_1.StyledArrow, { disabled: disabled },
                react_1.default.createElement(vobaza_ui_icon_1.Icon, { name: isOpen ? 'SmallArrowUp' : 'SmallArrowDown' })),
            react_1.default.createElement(input_select_styled_1.StyledInputContainer, { className: inputContainerClasses, hasError: error }, parsedValue),
            react_1.default.createElement(input_select_styled_1.StyledLabelWrapper, { className: "labelWrapper" },
                react_1.default.createElement(input_select_styled_1.StyledLabel, { className: "label", htmlFor: name }, label),
                required && react_1.default.createElement(input_select_styled_1.StyledRequiredStar, null, "*"))),
        isOpen &&
            (multiple ? (react_1.default.createElement(inputs_drawer_multiple_1.InputDrawerMultiple, { variants: variants, selected: normalizedValue, keyField: keyField, withSearch: withSearch, withNotion: Boolean(notion), valueField: valueField, onChange: handleChangeMultipleSelect, renderAfter: renderAfter, onRenderAfterClick: onRenderAfterClick, limit: typeof multiple === 'object' ? multiple.maxSelected : undefined })) : (react_1.default.createElement(inputs_select_drawer_1.InputsSelectDrawer, { variants: variants, keyField: keyField, withSearch: withSearch, withNotion: Boolean(notion), valueField: valueField, onChange: handleChangeSelect, renderAfter: renderAfter, onRenderAfterClick: onRenderAfterClick }))),
        react_1.default.createElement(input_select_styled_1.StyledNotion, { hasError: error }, error || notion)));
}
exports.InputSelect = InputSelect;
//# sourceMappingURL=input-select.js.map